/**
 * AI Usage Module Routes
 *
 * Single route for the AI usage dashboard.
 * Restricted to super_admin role.
 */

import type { RouteRecordRaw } from 'vue-router'
import ModuleLayout from '@/layouts/ModuleLayout.vue'

const routes: RouteRecordRaw[] = [
    {
        path: '/ai-usage',
        component: ModuleLayout,
        meta: {
            moduleKey: 'settings.ai_usage',
        },
        children: [
            {
                path: '',
                name: 'ai-usage-dashboard',
                component: () => import('./views/AiUsageDashboard.vue'),
                meta: {
                    title: 'AI Usage',
                },
            },
        ],
    },
]

export default routes
